import { useContext } from 'react'

import { ThemeContext } from '~/components/theme-provider'

/**
 * Hook personalizado para acessar o contexto do tema da aplicação.
 */
export function useTheme() {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error('useTheme deve ser usado dentro de um ThemeProvider do Pulso.')
  }

  return context
}
